module.exports = __webpack_public_path__ + "static/media/nexus_sc.ed46f1d6.png";